import React from 'react';
import { MUTED, SUBTLE } from './tokens';
import { useSoft } from './SurfaceStyleContext';

/** `← EVENTS / WINE + VINYL, SATURDAY AT THE BENCH` — 11px mono uppercase. */
export default function Breadcrumb({ backLabel, onBack, current, className = '' }) {
  const soft = useSoft();
  // Soft: 10px/700/.16em faint, `← EVENTS` in black.
  const size = soft ? 10 : 11;
  const spacing = soft ? '0.16em' : '0.1em';
  return (
    <div className={`flex min-w-0 items-center gap-2 ${className}`} data-testid="breadcrumb">
      <button type="button" onClick={onBack} className="whitespace-nowrap font-mono font-bold uppercase transition-colors duration-200 hover:text-black" style={{ fontSize: size, letterSpacing: spacing, color: soft ? '#000' : MUTED }}>← {backLabel}</button>
      {current && (
        <>
          <span className="font-mono" style={{ fontSize: size, color: SUBTLE }}>/</span>
          <span className="truncate font-mono font-bold uppercase" style={{ fontSize: size, letterSpacing: spacing, color: SUBTLE }}>{current}</span>
        </>
      )}
    </div>
  );
}
